import { Grid, Skeleton, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import React from "react";
import { useTranslation } from "react-i18next";
import { ManageMailLinks } from "src/widgetLink";
import { ManyEnvelops } from "../../../../assets/icons";
import { useAppSelector } from "../../../../custom-hooks/redux/redux";
import { MailInboxSummaryDTO } from "../../../../models/mail-inbox-summary/mail-inbox-summary-dto";
import { AUTHORIZATIONS } from "../../../../utils/constants/authorization-constants";

const UnclassifiedIncomingMailLink = ({
  customSummary,
  loading,
  linkId,
}: {
  customSummary: MailInboxSummaryDTO;
  loading: boolean;
  linkId: string;
}) => {
  const { t } = useTranslation();
  const tRP = "components.custom_widget_links.manage_mail";
  const theme = useTheme();

  const { currentUserAuthorizations } = useAppSelector((state) => state.currentUserReducer);

  const canClassifyIncoming = currentUserAuthorizations?.allowedDomains.includes(
    AUTHORIZATIONS.MailInboxAccess.CanClassifyIncoming ?? false
  );
  const canClassifyOutgoing = currentUserAuthorizations?.allowedDomains.includes(
    AUTHORIZATIONS.MailInboxAccess.CanClassifyOutgoing ?? false
  );

  const canClassifyOnlyIncoming = canClassifyIncoming && !canClassifyOutgoing;
  const canClassifyIncomingAndOutgoing = canClassifyIncoming && canClassifyOutgoing;

  return linkId === ManageMailLinks.UnclassifiedIncomingMailLink.id ? (
    (canClassifyOnlyIncoming && customSummary.unclassifiedIncoming > 0) ||
    (canClassifyIncomingAndOutgoing && customSummary.unclassifiedIncoming > customSummary.unclassifiedOutgoing) ||
    (canClassifyIncomingAndOutgoing && customSummary.unclassifiedIncoming === customSummary.unclassifiedOutgoing) ? (
      <Grid
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: "5px",
          width: "100%",
        }}
      >
        {loading ? (
          <Skeleton
            variant="rounded"
            width={"70%"}
            style={{ marginBottom: "2px" }}
          />
        ) : (
          <Grid
            style={{
              display: "flex",
              color: theme.palette.primary.main,
              justifyContent: "left",
              alignItems: "end",
              gap: "5px",
              width: "150px",
              margin: "3px 0px",
            }}
          >
            <ManyEnvelops style={{ width: "22px", height: "22px" }} />
            <Typography style={{ fontSize: "16px", lineHeight: "14px" }}>
              {(customSummary.unclassifiedIncoming ?? 0) + (customSummary.unclassifiedOutgoing ?? 0)}
            </Typography>
            <Typography style={{ fontSize: "16px", lineHeight: "14px", color: theme.palette.text.primary }}>
              {`${t(`${tRP}.unclassified`)}`}
            </Typography>
          </Grid>
        )}
      </Grid>
    ) : (
      <>{""}</>
    )
  ) : (
    <>{""}</>
  );
};
export default UnclassifiedIncomingMailLink;
